import TabsHeader from 'components/tabs-header';
import { useAccountState } from 'contexts/account/account-context';
import React from 'react';
import { Activity } from 'lucide-react';
import { useIntl } from 'react-intl';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const PlanningPrognosisTabsHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const { account } = useAccountState();
  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: account.company?.features.hasPlanningPrognosis || account.company?.features.hasPlanningPrognosisReadonly,
          label: intl.formatMessage({ id: 'planningPrognosis.navigation.listSites' }),
          to: '/planning-prognosis/sites',
        },
        {
          hasAccess: account.company?.features.hasOrderFreeDelivery,
          label: intl.formatMessage({ id: 'planningPrognosis.navigation.listNotifications' }),
          to: '/planning-prognosis/notifications',
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<Activity size={25} color={'white'} />}
    />
  );
};

export default React.memo(PlanningPrognosisTabsHeader);
